import * as People from "@/models/people";
import React from "react";
import { Trans } from "../i18n";
import i18n from "@/i18n";
import { activityAuthorName } from "../feedItemLinks";

import type { ActivityContentCompanyMemberRestoring } from "@/api";
import type { Activity } from "@/models/activities";

import type { ActivityHandler } from "../interfaces";

const CompanyMemberRestoring: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, _activity: Activity) {
    return paths.homePath();
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity }: { activity: Activity }) {
    const person = content(activity).person;

    if (person) {
      return (
        <Trans
          i18nKey="{{author}} restored {{personName}}'s account"
          values={{ author: activityAuthorName(activity), personName: People.firstName(person) }}
        />
      );
    }

    return <Trans i18nKey="{{author}} restored a member's account" values={{ author: activityAuthorName(activity) }} />;
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_activity: { activity: Activity }) {
    return i18n.t("Restored your account");
  },

  NotificationLocation(_props: { activity: Activity }) {
    return null;
  },
};

function content(activity: Activity): ActivityContentCompanyMemberRestoring {
  return activity.content as ActivityContentCompanyMemberRestoring;
}

export default CompanyMemberRestoring;
